import React from 'react';
import { Provider } from 'react-redux';

import CustomerWrapper from 'containers/CustomerWrapper/CustomerWrapper';
import ErrorBoundary from 'components/errors/ErrorBoundary';
import Routes from './Routes';

import store from './store/store';

import './App.css';

// We need types in Playmaker. For right now must use require.
// eslint-disable-next-line @typescript-eslint/no-var-requires
const { ThemeProvider } = require('@upperhand/playmaker');

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <Provider store={store}>
        <ErrorBoundary>
          <CustomerWrapper>
            <Routes />
          </CustomerWrapper>
        </ErrorBoundary>
      </Provider>
    </ThemeProvider>
  );
};

export default App;
